<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.counterId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.counterId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getCounterListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="50" :open-function="openItem"
          :dialogItem="editItem" :dialog-trigger="dialogtrigger" :dialog-method-config="dialogMethodConfig"
          ref="ListPane" :pk="pk" @Added="item => openItem(item)">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <CounterEditContent :key="trigger" :item="item" :editMode="true" :handleFocus="() => { }">
            </CounterEditContent>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/CounterListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import CounterEditContent from "./CounterEditContent.vue";

export default {
  name: "AdminCounterList",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup,
    CounterEditContent,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ACL-",
      dialogtrigger: 1,
      editItem: {},
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createCounter',
        },
      }
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "Counters") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewCounter', params: { counterId: item.Id }, query })
    },

    setEditItem(item) {
      if (item) {
        this.editItem = Object.assign({}, item);
      }
      else {
        var defaultItem = {
          Id: 0,
          Active: true,
          Global: false,
        };
        this.editItem = defaultItem;
      }
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>